import React from 'react';
import { CheckIcon, TargetIcon } from 'lucide-react';
import { tomes } from '../data/site';
import { SectionCta } from './SectionCta';
export function TomesSection() {
  return <section className="w-full bg-cream px-5 py-14 sm:px-6 sm:py-20" data-id="element-321" data-mp="3vh0r1uw3n4nt">
      <div className="mx-auto max-w-4xl" data-id="element-322" data-mp="3vgsgi9ng8bfs">
        <div className="text-center" data-id="element-323" data-mp="3cq4pbwa2dv0">
          <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-gold" data-id="element-324" data-mp="3bosv57ftnc8">What’s inside</p>
          <h2 className="mt-3 font-serif text-[28px] font-bold leading-[1.12] text-navy sm:text-4xl" data-id="element-325" data-mp="3lh9y3xn6sxpu">
            The complete 6-Tome Menopause Decision Desk™
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-[16px] leading-relaxed text-navy/70" data-id="element-326" data-mp="3cj80ls2nwn7b">
            Each tome is designed around a different stage of the clinical decision process. You don’t
            have to read them from beginning to end — each one answers a different question.
          </p>
        </div>

        <div className="mt-10 space-y-6" data-id="element-327" data-mp="1er3rsej7ip9z">
          {tomes.map(tome => <article key={tome.numeral} className="overflow-hidden rounded-2xl border border-navy/10 bg-white shadow-[0_18px_44px_-32px_rgba(12,21,38,0.4)]" data-id="element-328" data-mp="wcgsjzb7czts">
              <div className="px-5 pb-5 pt-5 sm:px-7 sm:pb-7 sm:pt-6" style={{
            borderTop: `4px solid ${tome.accent}`
          }} data-id="element-329" data-mp="163bj3fvhell1">
                <p className="text-[11px] font-bold uppercase tracking-[0.16em]" style={{
              color: tome.accent
            }} data-id="element-330" data-mp="115a1z0hm8wc7">
                  {tome.numeral}
                </p>
                <h3 className="mt-1.5 font-serif text-[23px] font-bold leading-tight text-navy sm:text-[27px]" data-id="element-331" data-mp="8h4ggbiqn3bb">
                  {tome.title}
                </h3>
                <p className="mt-2 font-serif text-[16px] font-semibold italic text-gold sm:text-[17px]" data-id="element-332" data-mp="icft8oal60gf">
                  {tome.tagline}
                </p>

                <div className="mt-4 space-y-3 text-[14.5px] leading-relaxed text-navy/70" data-id="element-333" data-mp="1tsmkmzknok08">
                  {tome.intro.map(paragraph => <p key={paragraph} data-id="element-334" data-mp="20v17uem4r4iu">{paragraph}</p>)}
                </div>

                <p className="mt-5 text-[11px] font-bold uppercase tracking-[0.12em] text-navy/45" data-id="element-335" data-mp="25tvy21mffvcz">
                  Inside you’ll find
                </p>
                <ul className="mt-3 grid gap-x-5 gap-y-2 sm:grid-cols-2" data-id="element-336" data-mp="2ft3beot5vq03">
                  {tome.items.map(item => <li key={item} className="flex items-start gap-2" data-id="element-337" data-mp="1i64d69mtma03">
                      <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-gold" aria-hidden="true" data-id="element-338" data-mp="1n4fnelh12miu" />
                      <span className="text-[14px] leading-snug text-navy/80" data-id="element-339" data-mp="1s3iqi0dg6io6">{item}</span>
                    </li>)}
                </ul>

                <div className="mt-5 flex items-start gap-2.5 rounded-xl bg-sand px-4 py-3.5" data-id="element-340" data-mp="1wvsdb7j9n2m8">
                  <TargetIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-341" data-mp="zebvhbd7cb7o" />
                  <p className="text-[14px] font-semibold leading-snug text-navy" data-id="element-342" data-mp="14cdejwamoaj5">
                    <span className="text-navy/55" data-id="element-343" data-mp="3hn6hcpratpzu">The goal: </span>
                    {tome.goal}
                  </p>
                </div>
              </div>
            </article>)}
        </div>

        <SectionCta headline="Six tomes. One pathway for every stage of the decision." label="Get all 6 tomes now" data-id="element-344" data-mp="38m889t206sae" />
      </div>
    </section>;
}